import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const LEN = () => {
  return (
    <CardSection id="LEN" title="LEN">
      <Paragraph>텍스트 문자열의 문자 수를 반환합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>LEN(STRING)</Paragraph>
        <Ul>
          <Li>
            <b>STRING</b>은 평가하려는 문자열입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>LEN(`School`)</Paragraph>
        <Img src="computeLen" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>STRING</b>은 텍스트 문자열, 텍스트 문자열을 포함하는 열
          또는 텍스트 문자열을 반환하는 함수여야 합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
